const initialState = {
    user: {},
    loginResult: false,
    logged: false,
    userToken: "",    
};

export const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case AuthConstant.LOGOUT:
            return { userToken: "", logged: false, loginResult: false };

        case AuthConstant.LOGIN_SUCCESS:
            return {
                logged: true,
                user: checkUserData(action.user),
                loginResult: true,
                userToken: action.userToken
            };
        case AuthConstant.LOGIN_FAIL:
            return {
                loginResult: true,
                logged: false
            };

        default:
            return state;
    }
}

const checkUserData = (user) => {
    if (!user)
        return user;
    if (!user.utype)
        user.utype = ['manager'];
    window?.localStorage?.setItem('user', JSON.stringify(user));

    return user;
}

export const AuthConstant = {
    LOGIN_SUCCESS: "AUTH_LOGIN_SUCCESS",
    LOGIN_FAIL: "AUTH_LOGIN_FAIL",
    UPDATED: "AUTH_UPDATED",
    LOGOUT: "AUTH_LOGOUT",
    SET_GROUP: "AUTH_SET_GROUP",
    ADD_RELATED_GROUP: "AUTH_ADD_RELATED_GROUP",
    SUB_RELATED_GROUP: "AUTH_SUB_RELATED_GROUP",
    SET_FIRST_SIGNIN_DATA: "AUTH_SET_FIRST_SIGNIN_DATA",
    SET_IS_WEB: "AUTH_SET_IS_WEB",
    SET_AUTH_REDIRECT: "AUTH_SET_AUTH_REDIRECT",
};